import { ContentContext, DatelineContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import getTimezone from 'Utils/getTimezone';

const Dateline = () => {
  const locale = useContext(LocaleContext);
  const dateline = useContext(DatelineContext);
  const content = useContext(ContentContext).common;

  const timestamp = new Date(dateline).toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
  const timezone = getTimezone();

  return (
    <div className={classnames('dateline', component)}>
      <SmartText
        source={content.dateline}
        context={{
          timestamp: <time dateTime={dateline}>{timestamp} {timezone}</time>,
        }}
        wrap
      />
    </div>
  );
};

export default React.memo(Dateline);
